import { createContext, useContext } from 'react';
import { LiquidInstanceConfiguration, Instance } from '../types/liquidInstance';

export interface LiquidInstanceContext {
  instances: Instance[];
  liquidInstanceConfiguration: LiquidInstanceConfiguration;
  wrap: boolean;
  setWrap: (wrap: boolean) => void;
  fromToken: string;
  toToken: string;
  normalizedAmount: bigint;
  setNormalizedAmount: (normalizedAmount: bigint) => void;
  setFromToken: (fromToken: string) => void;
  setToToken: (toToken: string) => void;
  setLiquidInstanceConfiguration: (liquidInstanceConfiguration: LiquidInstanceConfiguration) => void;
}

export const LiquidInstanceContext = createContext<LiquidInstanceContext | undefined>(undefined);

export const useLiquidInstanceContext = () => {
  const context = useContext(LiquidInstanceContext);
  if (context === undefined) {
    throw new Error('useLiquidInstanceContext must be used within a LiquidInstanceContextProvider');
  }
  return context;
};
